$(document).ready(function () {
  $("html, body").animate({ scrollTop: 0 }, "fast");
  $("#quizForm").find("input[type='checkbox']").prop("checked", false);
  $("#quizBranding").hide();
  $(".progress-container").hide();
  $("body").addClass("withBackgroundImage");
  $(".custom-scrollbar, .custom-scrollbar-2").hide();
  //$("#slide3Checkbox").click();

  function adjustSlideHeight() {
    var windowWidth = $(window).width();
    if (windowWidth > 1024) {
      var aspectRatioHeight = (1684 / 2880) * windowWidth;
      $(".slide0").css("height", aspectRatioHeight + "px");
      $("#questionnaire").css("height", aspectRatioHeight + "px");
      var slide0H1paddingTop = aspectRatioHeight * 0.06;
      $(".slide0 h1").css("padding-top", slide0H1paddingTop + "px");
    } else {
      $(".slide0").css("height", "100vh");
      $("#questionnaire").css("height", "100vh");
      $(".slide1").css("height", "100vh");
      $(".slide0 h1").css("padding-top", "10%");
    }
    if (windowWidth > 1024 && windowWidth < 1440) {
      //$(".slide0 h1").css("padding-top", "2%");
    }
  }

  function adjustSlideHeight2() {
    var windowWidth = $(window).width();
    if (windowWidth > 1024) {
      var aspectRatioHeight = (1684 / 2880) * windowWidth;
      //$(".slide0").css("height", aspectRatioHeight + "px");
      //$("#questionnaire").css("height", aspectRatioHeight + "px");
      var slide0H1paddingTop = aspectRatioHeight * 0.14;
      $(".slide0 h1").css("padding-top", slide0H1paddingTop + "px");
    } else {
      $(".slide0").css("height", "100vh");
      $("#questionnaire").css("height", "100vh");
      $(".slide1").css("height", "100vh");
      $(".slide0 h1").css("padding-top", "20%");
    }
    if (windowWidth > 1024 && windowWidth < 1440) {
      $(".slide0 h1").css("padding-top", "2%");
    }
  }

  // Initial call to set the height on page load
  adjustSlideHeight();

  // Adjust the height on window resize
  $(window).resize(function () {
    let activeSlide = $(".slide.active");
    if (activeSlide.hasClass("slide0")) {
      //adjustSlideHeight();
    } else {
      //adjustSlideHeight2();
    }
  });

  function validateSlide() {
    return $(".slide.active input[type='checkbox']:checked").length > 0;
  }

  function validateSlideSingle() {
    const checkedCheckboxes = $(".slide.active input[type='checkbox']:checked");
    return checkedCheckboxes.length === 1;
  }

  function adjustContainerHeight() {
    var activeSlideHeight = $(".slide.active").outerHeight();
    $("#questionnaire").height(activeSlideHeight);
  }

  /*function changeSlide($current, $next, direction) {
    $current
      .removeClass("active")
      .css("left", direction === "next" ? "-100%" : "100%");
    $next.addClass("active").css("left", "0");
    adjustContainerHeight();
    updateProgressBar($next.index());
  }*/

  function changeSlide($current, $next, direction) {
    $current
      .removeClass("active")
      .css("left", direction === "next" ? "-100%" : "100%");
    $next.addClass("active").css("left", "0");
    $(".slide.active .col-md-4").addClass("animated-div");
    adjustContainerHeight();
    updateProgressBar($next.index());
    updateBodyBackgroundColor($next);
  }

  function updateBodyBackgroundColor($nextSlide) {
    if ($nextSlide.is(":last-child")) {
      $("body").css("background-color", "white");
    } else {
      $("body").css("background-color", "");
    }
  }

  inputQuizSessionPosition("Intro_Screen");

  function updateProgressBar(index) {
    $("body").removeClass("withBackgroundImage");
    $("body").removeClass("whiteBG");
    $(".progress-bar").removeClass("active");

    if (index != 1) {
      $(".prev").show();
    }

    if (index >= 1 && index <= 11 && index !== 12) {
      console.log("Index:", index);
      $(".slide .nextButtonWrapper").hide();
      $("#questionnaire .slide" + index + " .nextButtonWrapper").show();
    }

    if (index === 1) {
      inputQuizSessionPosition("Question_1");
    }

    if (index === 2) {
      inputQuizSessionPosition("Question_2");
    }

    if (index === 3) {
      inputQuizSessionPosition("Question_3");
      //$("#compatibleResultsWrapper, #landingPageItems, #coverageCheckerA").hide();
      //$("body").css("background-color", "#000000");
      $("html, body").animate({ scrollTop: 0 }, "fast");
    }

    if (index < 13) {
      // Update for the progress bar
      $("#progress" + index).addClass("active");
    }

    if (index === 4) {
      inputQuizSessionPosition("Question_4");
    }

    if (index === 5) {
      inputQuizSessionPosition("Question_5");
    }

    if (index === 6) {
      inputQuizSessionPosition("Question_6");
    }

    if (index === 7) {
      inputQuizSessionPosition("Results_Page");
      $(".progress-container").hide();
      $("body").addClass("whiteBG");
      $("#quizBranding").hide();
      $(
        "#compatibleResultsWrapper, #landingPageItems, #coverageCheckerA"
      ).show(); //Hide coverage checker for now
      $("#webflowNav .nav-link-3.w-nav-link").show();
      //$("#coverageChecker #accordion .accordion-collapse").addClass("show");
      //$("#coverageCheckerA #accordion .accordion-collapse").addClass("show");
      $("#questionnaire").css("max-height", "480");
      $("#videoSection").show();
      $("#landingPageItems2, #landingPageItems3").show();
      if (window.innerWidth <= 768) {
        $(".custom-scrollbar, .custom-scrollbar-2").show();
        //$(".custom-scrollbar, .custom-scrollbar-2").css("display", "block");
      }
    } else {
      //$("body").css("background-color", "#252525");
      //$("body").css("background-color", "#000000");
      $(".progress-container").show();
      $("#quizBranding").show();
    }
  }

  function inputQuizSessionPosition(where) {
    var requestData = {
      "Source":"non-branded_quiz",
      "SessionEndWhere": where,
      "SessionType":"NonBranded"
    };

    $.ajax({
      url: "/apps/innova-api/quizz/session",
      type: "POST",
      data: requestData,
      success: function (response) {
        //alert("Data submitted successfully!");
      },
      error: function (xhr, status, error) {
        console.error(xhr);        
      },
    });
    
  }

  function updateValues(slideClass, textboxId) {
    /*let values = [];
    $(slideClass + " input[type='checkbox']").each(function () {
      let state = $(this).is(":checked") ? "ON" : "OFF";
      //values.push($(this).val() + " is " + state);
      values.push(state);
    });*/
    let values = [];
    $(slideClass + " input[type='checkbox']").each(function () {
      if ($(this).is(":checked")) {
        let label = $("label[for='" + $(this).attr("id") + "']").text();
        values.push(label);
      }
    });
    $(textboxId).val(values.join(", "));
  }

  function updateValuesSlide5(slideClass, textboxId) {
    let values = [];

    $(slideClass + " input[type='checkbox']").each(function () {
      if ($(this).is(":checked")) {
        let label = $("label[for='" + $(this).attr("id") + "']").text();
        values.push(label);
      }
    });

    const extraVal = $("#extraTextbox").is(":visible")
      ? $("#extraTextbox").val().trim()
      : "";

    if (extraVal) {
      values.push(extraVal);
    }

    // Combine, remove line breaks, collapse spaces
    const finalValue = values
      .join("--- ")
      .replace(/[\r\n]+/g, " ") // remove line breaks
      .replace(/\s+/g, " ") // collapse multiple spaces
      .trim(); // trim leading/trailing spaces

    $(textboxId).val(finalValue);
  }

  function updateValuesSlide3() {
    let values = [];
    $("#question3Year, #question3Make, #question3Model, #question3Engine").each(
      function () {
        values.push($(this).val());
      }
    );
    $("#textbox3").val(values.join(" "));
  }

  function getSlideData() {
    // Initial update for all slides
    updateValues(".slide1", "#textbox1");
    updateValues(".slide2", "#textbox2");
    updateValues(".slide3", "#textbox5");
    updateValues(".slide4", "#textbox4");
    updateValuesSlide3(".slide5", "#textbox3");
    updateValues(".slide6", "#textbox6");

    // Update on change for all slides
    $(".slide1 input[type='checkbox']").on("change", function () {
      updateValues(".slide1", "#textbox1");
    });
    $(".slide2 input[type='checkbox']").on("change", function () {
      updateValues(".slide2", "#textbox2");
    });
    $(".slide3 input[type='checkbox']").on("change", function () {
      updateValues(".slide3", "#textbox5");
    });
    $(".slide4 input[type='checkbox']").on("change", function () {
      updateValues(".slide4", "#textbox4");
    });
    $(".slide5 input[type='checkbox']").on("change", function () {
      updateValuesSlide3(".slide5", "#textbox3");
    });
    $(".slide6 input[type='checkbox']").on("change", function () {
      updateValues(".slide6", "#textbox6");
    });
  }

  $(".start-quiz").click(function () {
    var $current = $(".slide.active");
    var $next = $current.next(".slide");
    changeSlide($current, $next, "next");
    updateProgressBar(1);
    $(".progress-container").show();
    $("#quizBranding").show();
    const activeSlide = $(".slide.active");
    if (activeSlide.hasClass("slide1")) {
      $(".prev").hide();
    }
  });

  $(".next").click(function () {
    //$(".slideBranding").addClass("subsequentSlides");
    const activeSlide = $(".slide.active");

    if (activeSlide.hasClass("slide6-not-in-use") && !validateSlide()) {
      //alert("Please select at least one option.");
      $(".slide.active .col-md-4").addClass("allFieldsAreRequired");
      $(".errorMessage1").remove();
      $(".form-group").append(
        '<div class="errorMessage1">Select at least one above</div>'
      );
      return;
    }
    if (
      (activeSlide.hasClass("slide1") ||
        activeSlide.hasClass("slide2") ||
        activeSlide.hasClass("slide3") ||
        activeSlide.hasClass("slide4") ||
        activeSlide.hasClass("slide5-not-in-use") ||
        activeSlide.hasClass("slide6")) &&
      !validateSlideSingle()
    ) {
      $(".slide.active .col-md-4").addClass("allFieldsAreRequired");
      $(".errorMessage1").remove();
      $(".form-group").append(
        '<div class="errorMessage1">Select one above</div>'
      );
      return;
    }
    if (activeSlide.hasClass("slide5")) {
      if ($(".slide5 .unselected").length === 0) {
        //$("#searchCoverageBtn").click(); Moved to submitDatas()
        //$("#landingPageItems").show();
        $('#additionalDetail p:contains("Compatible with app.")').css(
          "margin-left",
          "10px"
        );
        //$("#coverageChecker #accordion .accordion-collapse").addClass("show");
        //$("#coverageCheckerA #accordion .accordion-collapse").addClass("show");
      } else {
        //alert("Please complete all fields.");
        //return false;
        $(".slide.active .col-md-4").addClass("allFieldsAreRequired");
        $(".errorMessage1").remove();
        $(".form-group").append(
          '<div class="errorMessage1">Select all fields</div>'
        );
        return;
      }
    }
    var $current = $(".slide.active");
    var $next = $current.next(".slide");

    //$current.find(".nextButtonWrapper").hide();
    //$next.find(".nextButtonWrapper").show();
    changeSlide($current, $next, "next");
    //$("html, body").animate({ scrollTop: 0 }, "fast");
    getSlideData();
  });

  $(".prev").click(function () {
    var $current = $(".slide.active");
    var $prev = $current.prev(".slide");
    //$current.find(".nextButtonWrapper").hide();
    //$prev.find(".nextButtonWrapper").show();
    changeSlide($current, $prev, "prev");
    const activeSlide = $(".slide.active");
    if (activeSlide.hasClass("slide1")) {
      $(".prev").hide();
    } else {
      $(".prev").show();
    }
  });

  $("#selectYearButton").click(function () {
    $(".slide.active .col-md-4").removeClass("allFieldsAreRequired");
    $(".errorMessage1").remove();
  });

  $(".col-md-4 .checkbox-card, .col-md-4 .selectCoverageItem").click(
    function () {
      //alert("hello!");
      $(".allFieldsAreRequired").removeClass("allFieldsAreRequired");
    }
  );

  function bestGreatGoodMatch() {
    var textbox5data = $("#textbox5").val();
    if (textbox5data != "" && textbox5data != "None") {
      // 5610 in Coverage Checker and comparo
      $("h3.goodMatch").text("Best Match");
      $("h3.bestMatch").text("Good Match");
      $(".actualComparisonTable tr").each(function () {
        var $cells = $(this).find("th, td");
        if ($cells.length > 1) {
          var $first = $cells.first();
          var $last = $cells.last();
          // Clone cells (including data and events)
          var firstClone = $first.clone(true);
          var lastClone = $last.clone(true);
          // Swap the cells
          $first.replaceWith(lastClone);
          $last.replaceWith(firstClone);
        }
      });
    }
    if (textbox5data == "" || textbox5data == "None") {
      // 1000 in Coverage Checker and comparo
      $("#searchToolDiv div #Tool").val("0x031C");
      $("#question3Tool").val("1000");
      $("#toolInnova5610").removeClass("selected");
      $("#toolInnova1000").addClass("selected");
    }
  }

  function submitDatas() {    
    $("#coverageCheckerSubmit2-slide6").click();
    $("#yourOBD2ScannerTabButton").click();
    $("#yourVehicleTabButton").click();    
    var textbox3a1 = $("#question3Year").val();
    var textbox3b1 = $("#question3Make").val();
    var textbox3c1 = $("#question3Model").val();
    $("#resultsText span.carYMME, #comparisonIntroParagraph span").html(
      textbox3a1 + " " + textbox3b1 + " " + textbox3c1
    );
    $("#chooseYourModel p span").html(textbox3b1);    

    getSlideData();

    requestData = {
      "Source":"non-branded_quiz",   
      "ResponseType":"NonBranded",
      "Question1": $("#textbox1").val(),
      "Question2": $("#textbox2").val(),
      "Question3": $("#textbox3").val(),
      "Question3a": $("#question3Year").val(),
      "Question3b": $("#question3Make").val(),
      "Question3c": $("#question3Model").val(),
      "Question3d": $("#question3Engine").val(),
      "Question4": $("#textbox4").val(),
      "Question5": $("#textbox5").val(),
      "Question6": $("#textbox6").val(),    
    };

    $.ajax({
      url: "/apps/innova-api/quizz/response",
      type: "POST",
      data: requestData,
      success: function (response) {
        //alert("Data submitted successfully!");
        console.log("Quizz's response submitted successfully!");
      },
      error: function (xhr, status, error) {
        console.error(xhr);        
      },
    });

  }

  $(".submit").click(function () {
    var $current1 = $(".slide.active");
    if ($current1.hasClass("slide6-not-in-use")) {
    } else {
      if (!validateSlide()) {
        //alert("Please select at least one option.");
        $(".slide.active .col-md-4").addClass("allFieldsAreRequired");
        $(".errorMessage1").remove();
        $(".form-group").append(
          /*'<div class="errorMessage1">Select at least one above</div>'*/
          '<div class="errorMessage1">Select one above</div>'
        );
        return;
      }
    }
    var $current = $(".slide.active");
    var $next = $current.next(".slide");
    $("html, body").animate({ scrollTop: 0 }, "fast");
    changeSlide($current, $next, "next");
    // Optionally, you can handle the form submission here
    updateValues(".slide6", "#textbox6");
    //$("#compareProductsWrapper").show();
    //bestGreatGoodMatch();
    submitDatas();
  });

  $(".go-to-slide-3").click(function () {
    var $current = $(".slide.active");
    var $target = $(".slide").eq(3); // Index 3 corresponds to the fourth slide (Question 3)
    changeSlide($current, $target, "next");
    updateProgressBar(3); // Update progress bar for Question 3
  });

  $(".go-to-slide-4").click(function () {
    var $current = $(".slide.active");
    var $target = $(".slide").eq(4); // Index 4 corresponds to the fifth slide (Question 4)
    changeSlide($current, $target, "next");
    updateProgressBar(4); // Update progress bar for Question 4
  });

  $(".go-to-slide-5").click(function () {
    var $current = $(".slide.active");
    var $target = $(".slide").eq(5); // Index 5 corresponds to the sixth slide (Question 5)
    changeSlide($current, $target, "next");
    updateProgressBar(5); // Update progress bar for Question 5
  });

  $("#coverageCheckerA #coverage-data .form-row").hide();
  $(".editVehicleForm").click(function () {
    //$("#coverageCheckerA #coverage-data .form-row").show();
    $("div#coverageChecker form#frmCoverage").show();
    $("#coverageCheckerA #coverage-data .form-row").css("display", "grid");
    $("#coverageCheckerA #coverage-data .form-row:nth-of-type(2)").css({
      display: "block",
      margin: "0 auto",
      "max-width": "400px",
    });
    $("#coverageCheckerA #coverage-data .form-row:nth-of-type(2) *").css({
      display: "block",
      padding: "0",
      margin: "0",
      "max-width": "400px",
    });
    $(
      "#coverageCheckerA #coverage-data .form-row:nth-of-type(2) #searchCoverageBtn"
    ).css("padding", "10px");
  });

  $(".go-to-slide-6").click(function () {
    var $current = $(".slide.active");
    var $target = $(".slide").eq(6);
    $("html, body").animate({ scrollTop: 0 }, "fast");
    changeSlide($current, $target, "next");
    updateProgressBar(6);
    //$("#compareProductsWrapper").show();
  });

  $(".go-to-slide-13").click(function () {
    var $current = $(".slide.active");
    var $target = $(".slide").eq(13);
    $("html, body").animate({ scrollTop: 0 }, "fast");
    changeSlide($current, $target, "next");
    updateProgressBar(13);
    ////$("#compareProductsWrapper").show();
  });

  $(".skipToResults").click(function () {
    var $current = $(".slide.active");
    const activeSlide = $(".slide.active");
    if (
      (activeSlide.hasClass("slide2-not-in-use") ||
        activeSlide.hasClass("slide4-not-in-use")) &&
      !validateSlideSingle()
    ) {
      $(".slide.active .col-md-4").addClass("allFieldsAreRequired");
      $(".errorMessage1").remove();
      $(".form-group").append(
        '<div class="errorMessage1">Select one above</div>'
      );
      return;
    }

    var $target = $(".slide").eq(6);
    changeSlide($current, $target, "next");
    updateProgressBar(6);
    updateValues(".slide5", "#textbox5");
    //bestGreatGoodMatch();
    submitDatas();
  });

  // Initial adjustment of container height
  adjustContainerHeight();

  // Checkbox card click handling
  $(".checkbox-card").click(function () {
    var $checkbox = $($(this).data("target"));
    var image = $(this).data("image");
    var placeholder = $(this).data("placeholder");
    var $imageContainer = $(this)
      .closest(".question-row")
      .find(".image-container img");
    var $activeSlide = $(this).closest(".slide");

    if (
      $activeSlide.is(
        ".slide1, .slide2, .slide3, .slide4, .slide5-not-in-use, .slide6"
      )
    ) {
      // Allow only one checkbox to be checked
      $activeSlide.find("input[type='checkbox']").prop("checked", false);
      $activeSlide.find(".checkbox-card").removeClass("checked");
    }

    $checkbox.prop("checked", !$checkbox.prop("checked"));
    $(this).toggleClass("checked", $checkbox.prop("checked"));
    $activeSlide
      .find(".nextButtonWrapper button")
      .toggleClass("checked", $checkbox.prop("checked"));

    if ($checkbox.prop("checked")) {
      //$imageContainer.not(".fiveStarReview").attr("src", image);
    } else {
      var checkedCheckboxes = $(this)
        .closest(".form-group")
        .find("input[type='checkbox']:checked");
      if (checkedCheckboxes.length > 0) {
        var newImage = checkedCheckboxes
          .first()
          .closest(".checkbox-card")
          .data("image");
        //$imageContainer.not(".fiveStarReview").attr("src", newImage);
      } else {
        $imageContainer.not(".fiveStarReview").attr("src", placeholder);
      }
    }
  });

  /*$(".checkbox-card.noneSelected").click(function () {
    $(".slide5 input[type='checkbox']").prop("checked", false);
    $(".slide5 .checkbox-card").removeClass("checked");
    $(".slide5 #q5a4").prop("checked", true);
    $(".slide5 .checkbox-card.noneSelected").addClass("checked");
  });

  $(".checkbox-card.normalClick").click(function () {
    $(".slide5 #q5a4").prop("checked", false);
    $(".slide5 .checkbox-card.noneSelected").removeClass("checked");
  });*/

  function fadeInNewImage() {
    //$(".image-container img").hide("fast").fadeIn(500);
    $(".image-container img").hide().fadeIn(500);
  }

  // Monitor for changes to the image's src attribute
  $(".image-container img").on("load", function () {
    fadeInNewImage();
  });

  var header = $("#shopify-section-header");
  var headerOffset = header.offset().top;

  $(window).on("scroll", function () {
    if ($(window).scrollTop() > headerOffset) {
      header.addClass("sticky");
    } else {
      header.removeClass("sticky");
    }
  });

  function checkCustomVisibility() {
    $(".customFadeInElement").each(function () {
      var elementTop = $(this).offset().top;
      var elementBottom = elementTop + $(this).outerHeight();
      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();

      if (elementBottom > viewportTop && elementTop < viewportBottom) {
        $(this).addClass("customVisible");
      }
    });
  }

  $(window).on("scroll resize", checkCustomVisibility);
  $(window).trigger("scroll");

  function syncSlideHeights() {
    var slide1Height = $(".slide1").outerHeight();
    $(".slide1, .slide2, .slide3, .slide4, .slide5, .slide6").height(
      slide1Height
    );
  }
  syncSlideHeights();
  $(window).resize(function () {
    syncSlideHeights();
  });

  if ($(window).width() < 768) {
    // Target mobile devices
    /*$(".third-column").css({
      "overflow-x": "scroll",
      "white-space": "nowrap",
    });*/
  }

  function adjustRowHeight() {
    if ($(window).width() < 768) {
      // Target mobile devices
      var colHeight = $("#deviceComparo .col-md-4").first().outerHeight();
      //$("#deviceComparo .row").css("height", colHeight);
    } else {
      //$("#deviceComparo .row").css("height", "auto");
    }
  }

  // Adjust height on page load
  adjustRowHeight();

  // Adjust height on window resize
  $(window).resize(function () {
    adjustRowHeight();
  });

  $(window).on(
    "resize",
    debounce(function () {
      //location.reload();
    }, 250)
  );

  function debounce(func, wait) {
    var timeout;
    return function () {
      clearTimeout(timeout);
      timeout = setTimeout(func, wait);
    };
  }

  function isMobile() {
    return window.innerWidth <= 768; // Adjust the width as needed for your definition of mobile
  }

  function togglePosition() {
    var $nextButtonWrapper = $(".nextButtonWrapper");
    if ($(window).scrollTop() === 0) {
      /*$nextButtonWrapper.css({
        position: 'fixed',
        top: '76vh',
      });*/
    } else {
      $nextButtonWrapper.css({
        position: "relative",
        boxShadow: "none",
      });
    }
  }

  function onScroll() {
    if (isMobile()) {
      togglePosition();
    }
  }

  // Initial check
  if (isMobile()) {
    togglePosition();
    $(window).on("scroll", onScroll);
  }

  // Check on resize
  /*$(window).on('resize', function() {
    if (isMobile()) {
      togglePosition();
      $(window).on('scroll', onScroll);
    } else {
      $(window).off('scroll', onScroll);
      $('.nextButtonWrapper').css({
        position: 'fixed',
        bottom: '0',
        //boxShadow: '0 -2px 5px rgba(0, 0, 0, 0.1)'
      });
    }
  });*/

  $(".copyCouponBtn").click(function () {
    var couponCode = $(this).data("code");
    var tempCopyField = $("<input>");
    $("body").append(tempCopyField);
    tempCopyField.val(couponCode).select();

    try {
      document.execCommand("copy");
      alert("Coupon code copied: " + couponCode);
    } catch (err) {
      alert("Failed to copy the coupon code.");
    }

    tempCopyField.remove();
  });

  const gadgetComparisonPanel = document.getElementById("landingPageItems3");
  const dynamicScrollIndicators = document.querySelectorAll(
    ".custom-scrollbar-thumb-2, .custom-scrollbar-thumb"
  );

  function adjustScrollIndicator() {
    const totalScrollableWidth =
      gadgetComparisonPanel.scrollWidth - gadgetComparisonPanel.clientWidth;
    const currentScrollPosition = gadgetComparisonPanel.scrollLeft;
    const indicatorWidth = (currentScrollPosition / totalScrollableWidth) * 100;

    dynamicScrollIndicators.forEach((indicator) => {
      indicator.style.width = `${Math.max(indicatorWidth, 30)}%`;
    });
  }

  adjustScrollIndicator();
  gadgetComparisonPanel.addEventListener("scroll", adjustScrollIndicator);
});

// Menu functions - consolidated
$(document).ready(function () {
  $(".burger-menu1A").click(function () {
    if ($(".main-content-container1").hasClass("menu-open")) {
      $(".main-content-container1").removeClass("menu-open");
      $(".mobile-menu1B").css("left", "-250px");
      $("body").removeClass("no-scroll"); // Re-enable scrolling
    } else {
      $(".main-content-container1").addClass("menu-open");
      $(".mobile-menu1B").css("left", "0");
      $("body").addClass("no-scroll"); // Disable scrolling
    }
  });

  function toggleMenu(buttonClass, panelId) {
    $(buttonClass).click(function () {
      var $panelCollapse = $(panelId);
      var $icon = $(this).find(".lin");

      // Close any open panels
      $("#pushy-menu .panel-collapse.in")
        .not($panelCollapse)
        .slideUp()
        .removeClass("in");
      $("#pushy-menu .lin-arrow-up")
        .not($icon)
        .removeClass("lin-arrow-up")
        .addClass("lin-arrow-down");

      // Toggle the clicked panel
      if ($panelCollapse.is(":visible")) {
        $panelCollapse.slideUp().removeClass("in");
        $icon.removeClass("lin-arrow-up").addClass("lin-arrow-down");
      } else {
        $panelCollapse.slideDown().addClass("in");
        $icon.removeClass("lin-arrow-down").addClass("lin-arrow-up");
      }
    });

    $("#pushy-menu .lin.lin-arrow-down").on("click", function () {
      $(this).toggleClass("lin-arrow-down lin-arrow-up");
    });
  }

  toggleMenu(
    "#pushy-menu .second_level_drop_link.products_2Button",
    "#pushy-menu #products_2"
  );
  toggleMenu(
    "#pushy-menu .second_level_drop_link.services_2Button",
    "#pushy-menu #services_2"
  );
  toggleMenu(
    "#pushy-menu .second_level_drop_link.support_4Button",
    "#pushy-menu #support_4"
  );

  // Show dialog and disable vertical scroll
  $("#nav-search-dialog-button").on("click", function () {
    $("#nav-search-dialog").show();
    $("#nav-search-dialog").attr("style", "display: block !important;");
    $("body").css("overflow", "hidden");
  });

  // Hide dialog and enable vertical scroll
  $("#nav-search-dialog-exit").on("click", function () {
    $("#nav-search-dialog").hide();
    $("#nav-search-dialog").attr("style", "display: none !important;");
    $("body").css("overflow", "auto");
  });

  $(".dropdown-products, .dropdown-support, .dropdown-services").hover(
    function () {
      $(this).closest(".dropdown").find(".dropdown-menu").show();
    },
    function () {
      $(this).closest(".dropdown").find(".dropdown-menu").hide();
    }
  );

  $(".dropdown-menu").hover(
    function () {
      $(this).show();
    },
    function () {
      $(this).hide();
    }
  );

  $(".lin.lin-arrow-down").on("click", function () {
    $(this).toggleClass("lin-arrow-down lin-arrow-up");
  });

  $("#closeMobileMenu, .no-scroll").on("click", function () {
    $("#pushy-menu-btn").trigger("click");
  });
});

// Tooltip
$(document).ready(function () {
  const jsonData = {
    "autoReLink-icon":
      "Auto-Relink automatically re-scans the vehicle at regular intervals, ensuring readiness monitors and key parameters are updated for SMOG testing and emissions compliance.",
    "codePriority-icon":
      "Code Priority refers to identifying the main fault code responsible for triggering your dashboard light. In many cases, resolving the primary fault code can also address related secondary codes that appear afterward.",
    "driveCycleProcedures-icon":
      "Drive Cycle Procedures refers to the ability of guiding you through each specific driving step to reset monitors for SMOG testing with real time instructions.",
    "bidirectionalSystemTest-icon":
      "Bidirectional System Tests let you control vehicle systems to identify issues. Common tests include actuator tests, EVAP system tests, injector balance tests, and solenoid tests.",
    "specialFunctionsRoutinesCalibrations-icon":
      "Special Functions refer to special reset features like SAS, DPF regen, EVAP VSV check, and more.",
    "all10ObdModes-icon":
      "<strong>Mode 01</strong> - I/M Readiness Status/Live Data Mode (PIDs)<br><strong>Mode 02</strong> - Freeze Frame Data<br><strong>Mode 03</strong> - Emission Related DTCs<br><strong>Mode 04</strong> - Erase DTCs<br><strong>Mode 05</strong> - Request O2 test results<br><strong>Mode 06</strong> - I/M Monitor Tests/Monitoring test results and parameters<br><strong>Mode 07</strong> - Two Trip Pending Diagnostic Trouble Code<br><strong>Mode 08</strong> - Request control of Onboard Component<br><strong>Mode 09</strong> - Request vehicle info<br><strong>Mode 10</strong> or <strong>Mode 0a</strong> - Permanent DTC",
    "all8ObdModes-icon":
      "<strong>Mode 01</strong> - I/M Readiness Status/Live Data Mode (PIDs)<br><strong>Mode 02</strong> - Freeze Frame Data<br><strong>Mode 03</strong> - Emission Related DTCs<br><strong>Mode 04</strong> - Erase DTCs<br><strong>Mode 05</strong> - Request O2 test results<br><strong>Mode 07</strong> - Two Trip Pending Diagnostic Trouble Code<br><strong>Mode 09</strong> - Request vehicle info<br><strong>Mode 10</strong> or <strong>Mode 0a</strong> - Permanent DTC",
    "secureGatewayForFCAvehicles-icon":
      "Secure Gateway access enables select scanners to unlock FCA vehicles' secure gateway by connecting through an AutoAuth account.",
    "batteryTooltip-unused": "Long-lasting battery life for extended usage.",
  };

  let activeTooltip = null;

  // Event delegation for dynamically added elements
  $("body").on("click", ".tooltipForComparo-trigger", function (e) {
    e.stopPropagation();

    // Close any existing tooltip
    if (activeTooltip) {
      activeTooltip.remove();
      activeTooltip = null;
    }

    const $trigger = $(this);
    const uniqueClass = $trigger
      .attr("class")
      .split(" ")
      .find((cls) => jsonData[cls]);

    const tooltipText = jsonData[uniqueClass] || "Tooltip not available.";

    // Create the tooltip dynamically
    const $tooltip = $('<div class="tooltipForComparo"></div>').html(
      tooltipText
    );

    // Append tooltip to the body
    $("body").append($tooltip);

    // Position the tooltip
    const rect = $trigger[0].getBoundingClientRect();
    const left = rect.left + window.scrollX;
    const top = rect.top + window.scrollY - $tooltip.outerHeight() - 10;

    $tooltip.css({
      left: `${left}px`,
      top: `${top}px`,
      display: "block",
    });

    activeTooltip = $tooltip;
  });

  // Close tooltip on outside click
  $(document).on("click", function () {
    if (activeTooltip) {
      activeTooltip.remove();
      activeTooltip = null;
    }
  });

  // Close tooltip on scroll
  $("#productComparo").on("scroll", function () {
    if (activeTooltip) {
      activeTooltip.remove();
      activeTooltip = null;
    }
  });

  // Handle tooltips inside Bootstrap modals
  $(document).on("shown.bs.modal", function (e) {
    const $modal = $(e.target);

    $modal.on("click", ".tooltipForComparo-trigger", function (e) {
      e.stopPropagation();

      // Close any existing tooltip
      if (activeTooltip) {
        activeTooltip.remove();
        activeTooltip = null;
      }

      const $trigger = $(this);
      const uniqueClass = $trigger
        .attr("class")
        .split(" ")
        .find((cls) => jsonData[cls]);

      const tooltipText = jsonData[uniqueClass] || "Tooltip not available.";

      // Create the tooltip dynamically
      const $tooltip = $('<div class="tooltipForComparo"></div>').html(
        tooltipText
      );

      // Append tooltip to the modal
      $modal.append($tooltip);

      // Position the tooltip
      const rect = $trigger[0].getBoundingClientRect();
      const left = rect.left;
      const top = rect.top - $tooltip.outerHeight() - 10;

      $tooltip.css({
        left: `${left}px`,
        top: `${top}px`,
        display: "block",
      });

      activeTooltip = $tooltip;
    });

    // Close tooltip on scroll inside the modal
    $modal.on("scroll", function () {
      if (activeTooltip) {
        activeTooltip.remove();
        activeTooltip = null;
      }
    });
  });
});

// Type option in .slide1
$(document).ready(function () {
  const $formGroup = $(".slide1 .form-group");
  const $checkboxCards = $formGroup.find(".checkbox-card");
  const $lastCard = $checkboxCards.last();
  const $textbox = $("#extraTextbox");

  $checkboxCards.on("click", function () {
    const isLast = $(this).is($lastCard);

    if (isLast) {
      $textbox.show();
    } else {
      $textbox.hide().val("");
    }
  });
  $("#extraTextbox").on("input", function () {
    $("#textbox1").val($(this).val());
  });
});

// Landing Page videos
const cvpVideoQueue = [
  {
    videoId: "cvp-video-find",
    barId: "cvp-progress-find",
    wrapperId: "cvp-card-find",
  },
  {
    videoId: "cvp-video-resolve",
    barId: "cvp-progress-resolve",
    wrapperId: "cvp-card-resolve",
  },
  {
    videoId: "cvp-video-save",
    barId: "cvp-progress-save",
    wrapperId: "cvp-card-save",
  },
];

function cvpPlayVideoAt(index) {
  // Stop and reset all videos
  cvpVideoQueue.forEach((v) => {
    const videoEl = document.getElementById(v.videoId);
    if (videoEl) {
      videoEl.pause();
      videoEl.currentTime = 0;
    }
  });

  // Reset all cards
  $(".cvp-card").removeClass("cvp-active");
  $(".cvp-card").parent().removeClass("cvp-col-active");

  // Reset all progress bars
  $(".cvp-progress-bar").css({
    width: "0%",
    backgroundColor: "#e0e0e0",
  });

  // Play selected video
  if (index >= 0 && index < cvpVideoQueue.length) {
    cvpCurrentIndex = index;
    cvpPlayNextVideo();
  }
}

$(".cvp-jump").on("click", function () {
  const index = $(this).data("index");
  cvpPlayVideoAt(index);
});

let cvpCurrentIndex = 0;

function cvpPlayNextVideo() {
  // Reset all cards
  $(".cvp-card").removeClass("cvp-active");
  $(".cvp-card").parent().removeClass("cvp-col-active");

  // Reset all bars to gray and width 0%
  $(".cvp-progress-bar").each(function () {
    $(this).css({
      width: "100%",
      backgroundColor: "#e0e0e0",
    });
  });

  const current = cvpVideoQueue[cvpCurrentIndex];
  const $video = $("#" + current.videoId);
  const $bar = $("#" + current.barId);
  const $wrapper = $("#" + current.wrapperId);

  // Activate current video and highlight its bar
  $wrapper.addClass("cvp-active");
  $wrapper.parent().addClass("cvp-col-active");
  $bar.css("backgroundColor", "var(--innova-red)");

  $video[0].currentTime = 0;
  $video[0].play();

  function updateCvpProgress() {
    const vid = $video[0];
    if (vid.duration) {
      const percent = (vid.currentTime / vid.duration) * 100;
      $bar.css("width", percent + "%");
      if (!vid.ended) requestAnimationFrame(updateCvpProgress);
    }
  }

  $video.off("ended").on("ended", () => {
    cvpCurrentIndex = (cvpCurrentIndex + 1) % cvpVideoQueue.length;
    cvpPlayNextVideo();
  });

  requestAnimationFrame(updateCvpProgress);
}

$(document).ready(() => {
  //cvpPlayNextVideo();
});

$("#watchVideosButton").on("click", function () {
  $("html, body").animate(
    {
      scrollTop: $("#actualVideos1").offset().top,
    },
    300
  );
  cvpCurrentIndex = 0;

  // Pause any currently playing video
  $(".cvp-video").each(function () {
    this.pause();
    this.currentTime = 0;
  });

  // Play the first video in sequence
  cvpPlayNextVideo();
});

$(window).on("scroll", function () {
  var $elem = $("#customerTypeTitle2");
  if ($elem.length && !$elem.data("played")) {
    var elemTop = $elem.offset().top;
    var elemBottom = elemTop + $elem.outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    if (elemTop < viewportBottom && elemBottom > viewportTop) {
      cvpPlayNextVideo();
      $elem.data("played", true); // Prevent retriggering
    }
  }
});

$(document).ready(function () {
  function setupMarquee() {
    const $list = $(".benefits-list");
    if (window.innerWidth <= 768 && !$list.hasClass("marquee-setup")) {
      $list.append($list.html()); // duplicate list items
      $list.addClass("marquee-setup"); // flag to avoid duplication
    }
  }

  setupMarquee(); // on page load

  $(window).on("resize", function () {
    setupMarquee(); // on window resize
  });

  // Initially hide all rows
  $(".advancedDiagnosticsRow, .essentialDiagnosticsRow").hide();

  // Toggle Essential Diagnostics
  $(".essentialDiagnosticsHeader").on("click", function () {
    $(".essentialDiagnosticsRow").toggle();
    let $icon = $(this).find(".toggle-icon");
    $icon.text($icon.text() === "+" ? "−" : "+");
  });

  // Toggle Advanced Diagnostics
  $(".advancedDiagnosticsHeader").on("click", function () {
    $(".advancedDiagnosticsRow").toggle();
    let $icon = $(this).find(".toggle-icon");
    $icon.text($icon.text() === "+" ? "−" : "+");
  });

  const allowedClasses = [
    "serviceChecks",
    "warningLights",
    "oemLiveData",
    "bidirectionalSystemTest",
    "specialFunctionsRoutinesCalibrations",
    "workshopTools",
  ];

  $(document).on("click", ".accordtionTitle", function () {
    const classes = $(this).attr("class").split(/\s+/);
    const match = classes.find((cls) => allowedClasses.includes(cls));

    if (match) {
      $(".accordionContent." + match).slideToggle(200);
      $(this).toggleClass("clicked");
    }
  });

  let syncing = false;

  function syncScroll($source, $target) {
    const source = $source.get(0);
    const atRight =
      source.scrollLeft + source.clientWidth >= source.scrollWidth;

    if (atRight) {
      $target.scrollLeft($target.get(0).scrollWidth);
      $source.scrollLeft(source.scrollWidth);
    } else {
      $target.scrollLeft($source.scrollLeft());
    }
  }

  $("#videoSection").on("scroll", function () {
    if (!syncing) {
      syncing = true;
      syncScroll($("#videoSection"), $("#landingPageItems3"));
      syncing = false;
    }
  });

  $("#landingPageItems3").on("scroll", function () {
    if (!syncing) {
      syncing = true;
      syncScroll($("#landingPageItems3"), $("#videoSection"));
      syncing = false;
    }
  });

  var swapped = false;

  function swapColumns() {
    var isMobile = $(window).width() <= 768;

    if (isMobile && !swapped) {
      $(".actualComparisonTable tr").each(function () {
        var $row = $(this);
        if ($row.find('[colspan="3"]').length === 0) {
          var $cells = $row.children();
          var $first = $cells.first();
          var $last = $cells.last();
          $first.before($last.detach());
        }
      });
      swapped = true;
    } else if (!isMobile && swapped) {
      // Revert swap
      $(".actualComparisonTable tr").each(function () {
        var $row = $(this);
        if ($row.find('[colspan="3"]').length === 0) {
          var $cells = $row.children();
          var $first = $cells.first();
          var $last = $cells.last();
          $last.after($first.detach());
        }
      });
      swapped = false;
    }
  }

  swapColumns();
  $(window).resize(swapColumns);

  // // Wait until Tidio is fully loaded
  // document.addEventListener("tidioChat-ready", function () {
  //   $("#openTidioChat").on("click", function () {
  //     // Open the Tidio chat widget
  //     tidioChatApi.open();
  //   });
  // });

  $("#openTidioChat").on("click", function () {    
    toggleInnovaChat();    
  });
  
});
